import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { OwnedParkingPriceRule } from '@repo/domain';
import { useOwnedParkingPriceRules } from '@repo/domain-service';

const PriceRulesContext = createContext<OwnedParkingPriceRule[] | undefined>(undefined);

interface Props {
  parkingId: string;
  children: ReactNode;
}

export function PriceRulesProvider({ parkingId, children }: Props) {
  const { ownedParkingPriceRules, loadingOwnedParkingPriceRules } = useOwnedParkingPriceRules({ parkingId });

  if (loadingOwnedParkingPriceRules) {
    return null;
  }

  return <PriceRulesContext value={ownedParkingPriceRules}>{children}</PriceRulesContext>;
}

export function usePriceRulesContext(): OwnedParkingPriceRule[] {
  const context = useContext(PriceRulesContext);
  if (context === undefined) {
    throw new Error('usePriceRulesContext must be used within PriceRulesProvider');
  }
  return context;
}
